import React from "react";
import moment from "moment";
import ProgressBar from "src/components/common/ProgressBar";
import styled from "styled-components";

const AsDetailInfo = (data: any) => {
  const detailData = data.data;

  return (
    <DetailInfoBox>
      {detailData ? (
        <>
          <div>
            <p className="category">{detailData.cate_name}</p>
            <p className="content">{detailData.contents}</p>
            <p className="date">{detailData.insert_date ? moment(detailData.insert_date).format("YYYY.MM.DD HH:mm") : "-"}</p>
          </div>
          <div className="status-box">
            <p className="sub-title">진행현황</p>
            <ProgressBar percent={detailData.progress_value} status={detailData.progress_name} cancel={detailData.delete_yn === "Y"} color="gray" />
          </div>
        </>
      ) : (
        ""
      )}
    </DetailInfoBox>
  );
};

const DetailInfoBox = styled.div`
  padding: 20px 15px;
  .category {
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: 700;
  }
  .content {
    margin-bottom: 15px;
    line-height: 20px;
    word-break: break-word;
    white-space: pre-wrap;
  }
  .date {
    color: #818181;
  }
  > div + .status-box {
    padding-top: 15px;
    margin-top: 15px;
    border-top: 1px solid ${({ theme }) => theme.color.linePrimary};
    .sub-title {
      color: #001827;
      font-size: 16px;
    }
  }
`;

export default AsDetailInfo;
